import React, { Component } from "react";
import PropTypes from "prop-types";
import LoadingWrapper from "../../common/loading-wrapper";
import { StackedBarChart, makeWidthFlexible } from "@unifiedpatents/euclid-react";
import { orderBy } from "@unifiedpatents/euclid-react/lib/helpers/preprocessors";
import { withChartConfig } from "../../common/chart-config-hoc";
import { countCasesByField } from "../../../services/api-reexam";
import { toTitleCase } from "../../../helpers/converters";

class FieldAggregation extends Component {
  static propTypes = {
    field: PropTypes.string.isRequired,
    filter: PropTypes.object,
    size: PropTypes.number,
    onSelectBar: PropTypes.func
  };

  static defaultProps = {
    filter: {}
  };

  state = {
    data: [],
    dataRaw: [], // for csv export
    loading: true
  };

  componentDidMount() {
    this._getData(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this._getData(nextProps);
    }
  }

  render() {
    const { loading } = this.state;
    return (
      <LoadingWrapper loading={loading} spinSize="large" style={{ minHeight: 250 }}>
        {this._renderChart()}
      </LoadingWrapper>
    );
  }

  _renderChart = () => {
    const { data } = this.state;
    const { size, field, onSelectBar, ...rest } = this.props;
    const height = (500 * size) / 20;
    const FlexibleStackedBarChart = withChartConfig(makeWidthFlexible(StackedBarChart), { data });
    const tickFormatY = label => (label.length > 10 ? `${label.slice(0, 10)}...` : label);
    return (
      <FlexibleStackedBarChart
        orientation="vertical"
        data={orderBy(data, undefined, "__total__")}
        height={height}
        margin={{ left: 100, right: 30, top: 60, bottom: 50 }}
        tickFormatX={val => (parseInt(val) >= 1000000 ? `${parseInt(val / 1000000)}m` : parseInt(val) >= 1000 ? `${parseInt(val / 1000)}k` : val)}
        tickTotalX={5}
        tickFormatY={tickFormatY}
        tooltipValueFormat={val => val.toLocaleString()}
        onValueClick={
          onSelectBar
            ? v => {
                let val = {
                  [field]: v.key
                };
                onSelectBar(val);
              }
            : undefined
        }
        {...rest}
      />
    );
  };

  _getData = props => {
    this.setState({ loading: true });
    const apiCall = countCasesByField;
    const valueField = "doc_count";
    const hoverKey = "Count";
    apiCall(props.filter, props.field, props.size)
      .then(res => {
        this.setState({
          data: this._reformatData(res, valueField, hoverKey),
          dataRaw: res,
          loading: false
        });
      })
      .catch(() => {
        this.setState({
          data: [],
          dataRaw: [],
          loading: false
        });
      });
  };

  _reformatData = (data, valueField, hoverKey) => {
    return [{ k: hoverKey, v: data.reverse().map(e => ({ k: toTitleCase(e.key), v: e[valueField] })) }];
  };
}

export default FieldAggregation;
